import '@shoelace-style/shoelace/dist/components/icon/icon.js';
